import { TimeMode } from './common'

/** 店家狀態 */
export enum BranchStatus {
  /** 0 = 啟用 */
  Enabled,
  /** 1 = 停用 */
  Disabled,
}

/** 店家類型 */
export enum BranchType {
  /** 0 = FunNow */
  FunNow,
  /** 1 = FunBook */
  FunBook,
  /** 2 = FunNow + FunBook 都開通 */
  Mix,
}

/** 店家來源 0: FunNow, 1: Inline, 2: Ebisol, 3: Tableapp, 4: ezding */
export enum BranchPlatform {
  /** 0 FunNow */
  FunNow,
  /** 1 Inline */
  Inline,
  /** 2 Ebisol */
  Ebisol,
  /** 3 Tableapp */
  TableApp,
  /** 4 ezding */
  EzDing,
}

/** 分店的方案選擇模式 */
export enum BranchReserveMode {
  /** 0: 先選擇方案 */
  ProductFirst,
  /** 1: 先選擇人數，再選時間 */
  HeadcountFirst,
  /** 2: 先選擇時間，再選方案 */
  TimeFirst,
}

export enum BranchBookingServiceKey {
  Products = 'Products',
  Headcounts = 'Headcounts',
  ArrivalTimes = 'ArrivalTimes',
}

export type BranchListQS = {
  size?: number
  sortby?: string
  lat?: number
  lng?: number
  filter_regionid?: number
  filter_keyword?: string
  filter_time?: string
  filter_times?: string[]
  filter_tag?: string
  filter_tags?: string
  starttime?: string
  endtime?: string
  min_price?: number
  max_price?: number
  min_branch_rating?: number
  source_category_id?: number
  limit?: number
  now?: number
  category_id?: number
}

type BranchBookingSourceQS = {
  /** 指定 product id */
  pid: number
  /** 指定人數 */
  headcount: number
  /** 指定販售時間 */
  booking_time: string
}

export type BranchHeadcountsQS = Partial<Omit<BranchBookingSourceQS, 'headcount'>>
export type BranchArrivalTimesQS = Partial<Omit<BranchBookingSourceQS, 'booking_time'>>
export type BranchProductsQS = Partial<Omit<BranchBookingSourceQS, 'pid'>>

export type ArrivalTimesResult = {
  start_day: string
  end_day: string
  time_mode: TimeMode
  timezone: string
  selldates: {
    [key: string]: {
      /** Morning, Afternoon ... */
      time_range_name: string
      selltimes: { selltime: string; price?: number; remain_count?: number }[]
    }[]
  } | null
  currency_id: number
  currency_symbol: string
}

export type FlattenArrivalTimesResult = {
  arrivalTimes: Record<string, string[]>
  bestOffPeak: string[]
  start_day: string
  end_day: string
  time_mode: TimeMode
  timezone: string
}

export type HeadcountsResult = {
  headcount: number[]
  default: number
}

export type ProductsResult = {
  address: string
  area: string
  bid: number
  branch_name: string
  cover_image: string
  currency_id: number
  description: string
  discount: number
  discount_ration: number
  distance: string
  duration: number
  fb_product_name: string
  flash_time: string
  flash_time_type: string
  has_detail: boolean
  images: string[]
  is_book_seat_only: boolean
  is_crossday: 0 | 1
  is_cust_num: 0 | 1
  is_favorite: boolean
  is_hot: boolean
  is_limited: boolean
  is_new_product: boolean
  is_now: boolean
  is_paid_onsite: boolean
  vip_reward: string
  birthday_reward: string
  lat: number
  lng: number
  number_of_comments: number
  onboard: 0 | 1
  product_id: number
  product_name: string
  rank: number
  rating: number
  rrp: number
  sales_mode: number
  sell_time: string
  sell_time_type: string
  srrp: number
  sub_item_max_sum: number
  sub_item_min_sum: number
  symbol: string
  symbol_code: string
}
